import { DataSource, Layout, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutStopNotesAndReferenceNumbers extends Layout {
    sourceReferenceNumber: DataSource;
    sourceStopNote: DataSource;
    tabStopComments: Tab;
    tabStopRefNumbers: Tab;
    tableStopComments: Table;
    tableStopReferenceNumbers: Table;
    tabsetStopNotesRefNos: Tabset;
}
